// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#ecasenkaDetail .shop-thank-you[data-v-9c7fb364] .transfer-info p{font-size:17px;font-weight:600}#ecasenkaDetail .shop-thank-you[data-v-9c7fb364] .qr-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;width:40%;min-width:170px;margin:20px auto 30px}#ecasenkaDetail .shop-thank-you[data-v-9c7fb364] .qr-wrapper img{width:100%}", ""]);
// Exports
module.exports = exports;
